// Environment
const env = process.env.MODE;
export const debug = ( env !== 'production' );
export const publicPath = process.env.PUBLIC_PATH;

// Authentication
export const isAuthGuardActive = true;
export const userRoles = {
	'Super Admin': 1,
	Admin: 2,
	Subscriber: 3
};

// Names
export const contextKey = '__promvc';

// Routes
export const adminRoot = '/admin';

// Language
export const defaultLocale = 'en';
export const localeOptions = [
	{ id: 'en', name: 'English', direction: 'ltr' },
	{ id: 'es', name: 'Español', direction: 'ltr' }
];